angular.module("vgresiduos").controller("EmbedPowerbiCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "dashboard-de-indicadores", [{ key: "tab", value: $stateParams.tab }]);
		};
	}
]);
